/**
 * This file is part of the "box" project.
 *
 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 */

;(function($) {
  $(document).ready(function() {

    // user log
    var userSearchButton = $('#form-admin-log-search').find('button'),
        userSearchSelect = $('#admin-log-user-search'),
        filterTypeSelect   = $('#admin-log-type'),
        filterStatusSelect = $('#admin-log-status'),
        filterClearButton  = $('#form-admin-log-filter-clear'),
        filterButton       = $('#form-admin-log-filter').find('button');

    filterTypeSelect.select2({
      placeholder: 'Select Type',
      width: '100%'
    });

    filterStatusSelect.select2({
      placeholder: 'Select Status',
      width: '100%'
    });

    filterButton.click(function() {

      var t = filterTypeSelect.val(),
          s = filterStatusSelect.val(),
          u = window.location.href;

      if(t && '' != t) {
        u = $.updateUrlParam(u, 'type', t);
      }

      if(s && '' != s) {
        u = $.updateUrlParam(u, 's', s);
      }

      window.location.href = u;

      return false;
    });

    filterClearButton.click(function() {
      var u =  window.location.href;

      u = $.removeUrlParam(u, 's');
      u = $.removeUrlParam(u, 'type');

      window.location.href = u;

      return false;
    });

    $('.debug-log-view').click(function () {
      var el = $(this);

      el.addClass('view');
    });

    $('.debug-log-view-single').click(function() {
      $(this).addClass('view');
    });

    // open full log data in modal on click (user-log "Data" column)
    $(document).on('click', '.js-log-data', function (e) {
      var $target = $(this);
      var text = $target.text();

      var $backdrop = $('<div class="log-data-modal-backdrop"></div>');
      var $modal = $('<pre class="log-data-modal"></pre>').text(text);

      $backdrop.on('click', function () {
        $modal.remove();
        $backdrop.remove();
      });

      $('body').append($backdrop).append($modal);
    });

    userSearchSelect.select2({
      width: '100%',
      // dir: "rtl",
      containerCssClass: 'admin-control-search',

      ajax: {
        delay: 250,
        url: '/admin/user-log/search',
        placeholder: 'This is my placeholder',
        allowClear: true,
        data: function(params) {
          let term = params.term;
          // Convert non-ASCII domains to punycode
          if (term && /[^\x00-\x7F]/.test(term)) {
            try {
              term = new URL('http://' + term).hostname;
            } catch(e) {}
          }
          return {q: term};
        },
        processResults: function (data, params) {
          // parse the results into the format expected by Select2
          // since we are using custom formatting functions we do not need to
          // alter the remote JSON data, except to indicate that infinite
          // scrolling can be used
          params.page = params.page || 1;

          var formattedData = [];

          $.each(data, function(subject, elements) {
            if(Object.keys(elements).length > 0) {
              var children = [];
              var type     = subject;

              if('users' == subject) {
                type = 'u';
              }

              if('contacts' == subject) {
                type = 'c';
              }

              if('domains' == subject) {
                type = 'd';
              }

              $.each(elements, function(id, name) {
                children.push({id: id, text: name, group: subject, type: type});
              });

              formattedData.push({id: subject, text: $.ucfirst(subject), children: children});
            }
          });

          return {
            results: formattedData
            // pagination: {
            //   more: (params.page * 30) < data.total_count
            // }
          };
        },
        escapeMarkup: function (markup) { return markup; }, // let our custom formatter work
        minimumInputLength: 3
      }
    }).on('select2:select', function(e) {
      userSearchButton.prop('disabled', false);
    });

    userSearchButton.click(function() {
      var data = userSearchSelect.select2('data');

      if(0 == data.length) {
        $(this.prop('disabled', true));

        return false;
      }

      var selected = data[0];

      // redirect
      window.location.href = Storage.getData('app_url') + 'admin/user-log?' + selected.type + '=' + selected.id;
      return false;
    });


    $(document).on('click', '.admin-op-domain-update-status', function (e) {
      e.preventDefault();
      var status = $(this).attr('data-status');
      var con = confirm('Are you sure to change domain status to ' + status + '?');

      if (con) {
        $.ajax({
          url: $(this).attr('href'),
          type: 'POST',
          data: {
            'status': status,
          },
          success: function () {
            alert('Well done! Status was updated successfully.');
            $('#admin-domain-op-errors').html('').addClass('hidden');
          },
          error: function (xhr) {
            if (403 === xhr.status) {
              window.location.href = '/user/login';
            }

            $('#admin-domain-op-errors').html(xhr.responseJSON.msg).removeClass('hidden');
          }
        });
      }
    });

    var invoiceResendBtn = null;

    $(document).on('click', '.admin-invoice-resend', function (e) {
      e.preventDefault();
      var el = $(this);
      if (el.is(':disabled') || el.data('busy')) {
        return;
      }

      invoiceResendBtn = el;
      $('#admin-invoice-resend-confirm').modal('show');
    });

    $(document).on('click', '#admin-invoice-resend-confirm-cancel', function () {
      invoiceResendBtn = null;
      $('#admin-invoice-resend-confirm').modal('hide');
    });

    $(document).on('click', '#admin-invoice-resend-confirm-ok', function () {
      var el = invoiceResendBtn;
      invoiceResendBtn = null;
      $('#admin-invoice-resend-confirm').modal('hide');

      if (!el) {
        return;
      }

      el.data('busy', true).prop('disabled', true);

      $.ajax({
        url: el.data('url'),
        type: 'POST',
        dataType: 'json'
      }).done(function (r) {
        var msg = (r && r.msg) ? r.msg : '';
        if (r && r.status == 1) {
          $.showSuccess(r.title || $.translate('Success'), msg, false, true);
        } else {
          $.showError(msg || 'שליחת החשבונית נכשלה');
        }
      }).fail(function (xhr) {
        if (403 === xhr.status) {
          window.location.href = '/admin/login';
          return;
        }
        $.showError('שליחת החשבונית נכשלה');
      }).always(function () {
        el.data('busy', false).prop('disabled', false);
      });
    });

    // invoice list: show / hide the credit notes and cancelled invoices under the invoice in effect
    $(document).on('click keydown', '.invoice-tree-toggle', function (e) {
      if (e.type === 'keydown' && e.which !== 13 && e.which !== 32) {
        return;
      }
      e.preventDefault();

      var el       = $(this),
          expanded = el.attr('aria-expanded') !== 'true';

      el.attr('aria-expanded', expanded ? 'true' : 'false');
      el.find('.glyphicon')
        .toggleClass('glyphicon-chevron-down', expanded)
        .toggleClass('glyphicon-chevron-left', !expanded);
      el.closest('tbody')
        .find('tr[data-invoice-group="' + el.data('invoice-group') + '"]')
        .not('.invoice-tree-root')
        .toggleClass('hidden', !expanded);
    });

    var invoiceReissueBtn = null;

    $(document).on('click', '.admin-invoice-reissue', function (e) {
      e.preventDefault();
      var el = $(this);
      if (el.is(':disabled') || el.data('busy')) {
        return;
      }

      var retry = 1 == el.data('retry');

      invoiceReissueBtn = el;
      $('#admin-invoice-reissue-text').toggleClass('hidden', retry);
      $('#admin-invoice-reissue-retry-text').toggleClass('hidden', !retry);
      $('#admin-invoice-reissue-name').val('');
      $('#admin-invoice-reissue-error').html('').addClass('hidden');
      $('#admin-invoice-reissue-confirm-ok').prop('disabled', false);
      $('#admin-invoice-reissue-confirm').modal('show');
    });

    $(document).on('click', '#admin-invoice-reissue-confirm-cancel', function () {
      invoiceReissueBtn = null;
      $('#admin-invoice-reissue-confirm').modal('hide');
    });

    $(document).on('click', '#admin-invoice-reissue-confirm-ok', function () {
      var el    = invoiceReissueBtn,
          ok    = $(this),
          error = $('#admin-invoice-reissue-error'),
          name  = $.trim($('#admin-invoice-reissue-name').val());

      if (!el) {
        return;
      }

      if (!name) {
        error.html('יש להזין שם לחשבונית החדשה').removeClass('hidden');
        return;
      }

      error.html('').addClass('hidden');
      ok.prop('disabled', true);
      el.data('busy', true).prop('disabled', true);

      $.ajax({
        url: el.data('url'),
        type: 'POST',
        dataType: 'json',
        data: {
          'name': name
        }
      }).done(function (r) {
        if (r && r.status == 1) {
          invoiceReissueBtn = null;
          $('#admin-invoice-reissue-confirm').modal('hide');
          // reload on close so the list shows the credit note and the new invoice
          $.showSuccess(r.title || $.translate('Success'), r.msg || '');
        } else {
          error.html((r && r.msg) ? r.msg : 'ההנפקה המחודשת נכשלה').removeClass('hidden');
        }
      }).fail(function (xhr) {
        if (403 === xhr.status) {
          window.location.href = '/admin/login';
          return;
        }
        error.html('ההנפקה המחודשת נכשלה').removeClass('hidden');
      }).always(function () {
        ok.prop('disabled', false);
        el.data('busy', false).prop('disabled', false);
      });
    });

    $(document).on('click', '.admin-op-domain-delete', function (e) {
      e.preventDefault();
      var status = $(this).attr('data-status');
      var con = confirm('Are you sure to delete selected domain?');

      if (con) {
        $.ajax({
          url: $(this).attr('href'),
          type: 'POST',
          data: {
            'status': status,
          },
          success: function () {
            alert('Well done! Domain was deleted successfully.');
            $('#admin-domain-op-errors').html('').addClass('hidden');
            window.location.reload();
          },
          error: function (xhr) {
            if (403 === xhr.status) {
              window.location.href = '/user/login';
            }

            $('#admin-domain-op-errors').html(xhr.responseJSON.msg).removeClass('hidden');
          }
        });
      }
    });


    // section for verify-view.php
    var admin_dverify_form = $("#admin-dverify-form");
    admin_dverify_form.find(":input[type=text]").prop("disabled", true);
    admin_dverify_form.find(":input[type=radio]").prop("disabled", true);
    admin_dverify_form.find(":input[type=submit]").prop("disabled", true);

    var pr_input = admin_dverify_form.find(":input[name='name']");
    var org_input = admin_dverify_form.find(":input[name='organization_name']");
    var orgid_input = admin_dverify_form.find(":input[name='organization_number']");
    var admin_dverify_form_org = admin_dverify_form.attr("org");

    var admin_dverify_edit_btn = $("#admin-dverify-edit-button");
    
    // disable or enable fields by owner type related to current owner type
    $(admin_dverify_edit_btn).click(function(event){
        event.preventDefault();
        admin_dverify_form.find(":input").prop("disabled", false);
        admin_dverify_edit_btn.prop("disabled", true);
        if(admin_dverify_form_org){
            org_input.prop("disabled", false);
            orgid_input.prop("disabled", false);
            pr_input.prop("disabled", true);
            //pr_input.val(null);
        }else{
            org_input.prop("disabled", true);
            orgid_input.prop("disabled", true);
            pr_input.prop("disabled", false);
            org_input.val(null);
            orgid_input.val(null);  
        }
    });

    //disable form on click outside
    $("#admin-verify-edit-table").click(function(event){
        if (!$(event.target).closest("#admin-dverify-form").length) {
            admin_dverify_form.find(":input").prop("disabled", true);
            admin_dverify_edit_btn.prop("disabled", false);
        }
    });

    // disable or enable fields by owner type of radio button
    admin_dverify_form.on("change", "input[name='owner-type']", function () {

        if($(this).val() == "private"){
            if(confirm("Are you sure you want to change the holder to a private entity?")){
                org_input.prop("disabled", true);
                orgid_input.prop("disabled", true);
                pr_input.prop("disabled", false);
                org_input.val(null);
                orgid_input.val(null);
            }else{
                $("#owner-org").prop("checked", true);
            }
            
        }else{
            if(confirm("Are you sure you want to change the holder to a organization entity?")){
                org_input.prop("disabled", false);
                orgid_input.prop("disabled", false);
                org_input.prop("required", true);
                orgid_input.prop("required", true);
                pr_input.prop("disabled", true);
            }else{
                $("#owner-pr").prop("checked", true);
            }
        }
    });

    // fill org input to owener name
    org_input.on("input", function() {
        let value = $(this).val();
        pr_input.val(value);
    });


    // reject verify
    $("#admin-domain-reject-verify").click(function(event){
        event.preventDefault();
        $("#admin-domain-reject-verify-reason").removeClass("hidden");
        var reason = $("#admin-domain-reject-verify-reason").val();
        if(!reason || reason.trim() == ""){
          alert("Please enter a reason for rejection");
            return;
        }
        
        var target = $(this).data("url-target");
        $(this).prop("disabled", true);
        $.ajax({
            url: target,
            type: 'POST',
            data: {
                'reason': reason
            },
            success: function(response){
              window.location.href = response.redirect;
            },
            error: function(xhr){ 
                $('#admin-domain-reject-verify-reason').replaceWith('<div class="alert alert-danger">' + xhr.responseJSON.msg + '</div>');
                $(this).prop("disabled", false);
            }
        });
    });

    // approve verify
    $("#admin-domain-approve-verify").click(function(event){
        event.preventDefault();
        var target = $(this).data("url-target");
        $(this).prop("disabled", true);
        $.ajax({
            url: target,
            type: 'POST',
            success: function(response){
              window.location.href = response.redirect;
            },
            error: function(xhr){ 
                $('#admin-domain-approve-verify').replaceWith('<div class="alert alert-danger">' + xhr.responseJSON.msg + '</div>');
                $(this).prop("disabled", false);
            }
        });
    });
  });
})(jQuery);